// client/src/routes/app/tenants/index.tsx — SCR-TEN-001 · TEN-004 (04 §8.4).
//
// Replaces UI-003's `PlaceholderScreen`, which was here so that its "all V1 module routes exist
// in the sidebar, may point to placeholder pages" criterion would be literally true, and which
// named this item as its owner. PROP-004's deviation 369 moved the test that pins that
// behaviour onto THIS route when `/app/properties` became real; it moves on again here, to the
// next unbuilt screen. See DEVIATIONS D-378.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema, and
// the screen reads it back typed. Filters therefore survive refresh, are shareable, and Back is
// a filter-undo.
//
// The `Leasing.Read` guard is UI-003's and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { TenantList } from '@/features/tenants/TenantList';
import { tenantSearchSchema, type TenantSearch } from '@/features/tenants/search';

export const Route = createFileRoute('/app/tenants/')({
  validateSearch: tenantSearchSchema,
  component: TenantsScreen,
});

function TenantsScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Leasing.Read">
      <TenantList
        search={search}
        onSearchChange={(next: (previous: TenantSearch) => TenantSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
